<template>
    <div class="form-check">
        <input type="checkbox" :id="field"
               class="form-check-input"
               :class="{
                     'is-invalid': errors && errors.has(field)
                 }"
               :checked="value"
               :disabled="disabled"
               @input="$emit('input', $event.target.checked)">
        <label class="form-check-label" :for="field">
            {{ label }}
            <slot/>
        </label>
        <AppError v-if="errors" :errors="errors" :field="field"/>
    </div>
</template>

<script>

import AppError from './AppError';

export default {
  components: {
    AppError,
  },
  props: ['errors', 'label', 'value', 'field', 'disabled'],
};
</script>
